/**
 * Platform detection shared by PLAYER (input scheme) and UI (prompt copy).
 * Coarse-pointer media query is the spec-blessed signal; the ontouchstart
 * fallback catches older WebViews that lie about pointer capability.
 */
export const isTouchDevice = (): boolean =>
  window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window
